/**
 * Show a confirmation popup and reload the page once the user clicks OK.
 *
 * Use this from every save/create/update/delete success branch so the UX is
 * consistent: blocking popup → user acknowledges → full page reload to fetch
 * fresh state.
 *
 * Don't use this in error paths — those should stay non-reloading so the user
 * can see what went wrong.
 */
export function notifySavedAndReload(message = '✓ Saved successfully') {
  // eslint-disable-next-line no-alert
  window.alert(message);
  window.location.reload();
}
